export default "__VITE_ASSET__BiVmooX0__"